<template>
  <div>
    <div v-if="errorStatus" class="alert alert-danger my-3" role="alert" v-html="errorStatus">
      
    </div>
    <div v-if="executionStatusLabel" class="alert alert-danger my-3" role="alert" >
      <div v-html="executionStatusLabel" />
      <div v-if="executionStatus===1" class="pt-2"><button type="button" class="btn btn-sm btn-primary" :class="{'disabled opacity-50':adminSelectedUser}" @click="!adminSelectedUser && updatePaymentMethod()">{{$t('messages.updatepaymentmethod')}}</button></div>
      <div v-if="executionStatus===2" class="pt-2"><button type="button" class="btn btn-sm btn-primary" :class="{'disabled opacity-50':adminSelectedUser}" @click="!adminSelectedUser && reenableAccount()">{{$t('messages.attemptreenable')}}</button></div>
    </div>
    <div v-if="subscriptionStatusLabel" class="alert alert-danger my-3" role="alert">
      <div v-html="subscriptionStatusLabel" />
      <div v-if="subscriptionStatus==='past_due' || subscriptionStatus==='unpaid'" class="pt-2"><button type="button" class="btn btn-sm btn-primary" :class="{'disabled opacity-50':adminSelectedUser}" @click="!adminSelectedUser && updatePaymentMethod()">{{$t('messages.updatepaymentmethod')}}</button></div>
    </div>
    <div v-if="!isContainerInited" class="d-flex align-items-center justify-content-center" style="min-height:300px">
      <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">{{$t('messages.loading')}}</span>
        </div>
        {{$t('messages.loading')}}
    </div>
    <div v-else-if="!hasSession" class="alert alert-warning d-flex align-items-center my-3" role="alert">
      <i class="bi bi-lock me-3 fs-4"></i>
      <div class="flex-grow-1">
        <strong>{{ $t('messages.signinrequired') }}</strong>
        <p class="mb-0 small">{{ $t('messages.signinrequireddesc') }}</p>
      </div>
      <a class="btn btn-primary btn-sm" href="#" onclick="window.dialogManager?.showSignIn(); return false;">
        <i class="bi bi-box-arrow-in-right me-1"></i>{{ $t('messages.signin') }}
      </a>
    </div>
    <div v-else-if="isLoading" class="d-flex align-items-center justify-content-center" style="min-height:300px">
        <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">{{$t('messages.loading')}}</span>
        </div>
        {{$t('messages.loading')}}
    </div>
    <div v-else class="row">

      <!-- Admin user search -->
      <div v-if="isAdmin" class="col-12 card border-0 shadow-sm mb-3 p-3">
        <div class="d-flex align-items-center mb-2">
          <i class="bi bi-shield-lock me-2 text-primary"></i>
          <strong>Admin: Look up user account</strong>
        </div>
        <div class="input-group input-group-sm">
          <input type="text" class="form-control" v-model="adminSearchCriteria" 
            placeholder="Enter username or API key" 
            @keyup.enter="adminFindUser()" :disabled="isAdminSearching" />
          <button class="btn btn-outline-primary" @click="adminFindUser()" :disabled="isAdminSearching || !adminSearchCriteria">
            <span v-if="isAdminSearching" class="spinner-border spinner-border-sm me-1"></span>
            Search
          </button>
          <button v-if="adminSelectedUser" class="btn btn-outline-secondary" @click="adminClearSearch()">
            Back to My Account
          </button>
        </div>
        <div v-if="adminSearchError" class="text-danger mt-2 small">{{adminSearchError}}</div>
        
        <!-- Search results dropdown -->
        <div v-if="adminSearchResults && !adminSelectedUser" class="mt-2">
          <div v-if="!adminSearchResults.results || !adminSearchResults.results.length" class="text-muted small">No users found.</div>
          <div v-else class="list-group list-group-flush">
            <a v-for="result in adminSearchResults.results" :key="result.groupId" href="#"
              class="list-group-item list-group-item-action d-flex align-items-center py-2 px-3"
              @click.prevent="adminSelectUser(result)">
              <span class="me-2">{{result.username}}</span>
              <span v-if="result.isMasterGroup" class="badge bg-warning text-dark me-1">Group</span>
              <span v-if="result.isAdmin" class="badge bg-primary me-1">Admin</span>
              <span v-if="result.matchType==='child'" class="badge bg-info me-1">Child</span>
            </a>
          </div>
          <div v-if="adminSearchResults.truncated" class="text-muted small mt-1">Results truncated. Try a more specific search.</div>
        </div>
        
        <!-- Selected user banner -->
        <div v-if="adminSelectedUser" class="alert alert-info mt-2 mb-0 py-2 d-flex align-items-center">
          <i class="bi bi-person-fill me-2"></i>
          Viewing account for: <strong class="ms-1">{{adminSelectedUser}}</strong>
        </div>
      </div>
    
      <div class="col-12 card card-body border-0 shadow-sm py-2 px-4">
        <h4 class="mt-3 mb-2">{{$t('messages.yourdetails')}}</h4>
       
        <div class="row">

          <div class="mb-3 col-12 col-md-6 col-xl-3" >
            <div class="fw-bold fs-xs mb-1"><i class="bi bi-person"></i> {{$t('messages.username') || 'Username'}}</div>
            <div>{{username}}</div>
            <div class="mt-n2">
              <a href="#" @click.prevent="!adminSelectedUser && startUsernameChange()" class="btn btn-sm ms-0 ps-0" :class="adminSelectedUser?'text-muted pe-none':'text-primary'">{{$t('messages.changeusername')}}</a>
            </div>
            <div class="mt-n2">
              <a href="#" @click.prevent="!adminSelectedUser && startChangePassword()" class="btn btn-sm ms-0 ps-0" :class="adminSelectedUser?'text-muted pe-none':'text-primary'">{{$t('messages.changepassword')}}</a>
            </div>
            <div class="mt-n2">
              <a href="#" class="btn btn-sm ms-0 ps-0" :class="adminSelectedUser?'text-muted pe-none':'text-primary'" @click.prevent="!adminSelectedUser && openModal('emailPrefs')">{{$t('messages.emailprefs.title')}}</a>
            </div>
          </div>

          <div class="mb-3 col-12 col-md-6 col-xl-3" >
            <div class="fw-bold fs-xs mb-1"><i class="bi bi-code-slash"></i> {{$t('messages.key')}}</div>
            <div class="fs-sm">{{apiKey}}</div>
            <div class="mt-n2">
              <a href="#" class="btn btn-sm ms-0 ps-0" :class="adminSelectedUser?'text-muted pe-none':'text-primary'" @click.prevent="!adminSelectedUser && copyKey()">{{isCopying?$t('messages.copying'):$t('messages.copy')}}</a>
              <a href="#" class="btn btn-sm ms-0 ps-0" :class="adminSelectedUser?'text-muted pe-none':'text-primary'" @click.prevent="!adminSelectedUser && changeApiKey()">{{$t('messages.change')}}</a>
            </div>
            <div class="mt-n2">
              <a href="#" class="btn btn-sm ms-0 ps-0" :class="adminSelectedUser?'text-muted pe-none':'text-primary'" @click.prevent="!adminSelectedUser && changeSecret()">{{$t('messages.createsecret')}}</a>
            </div>
            <!--<div class="mt-n2 fs-sm">API Version: {{apiVersion}}</div>-->
          </div>
          




          <div class="mb-3 col-12 col-md-6 col-xl-3">
              <template v-if="!noAdminPermissions">
                <div class="fw-bold fs-xs mb-1"><i class="bi bi-currency-dollar"></i> {{$t('messages.paymentmethod')}}</div>
                <div v-if="hasPaymentMethod" class="d-flex">
                  <div class="text-truncate">{{paymentMethod}}</div>
                </div>
                <div v-else>
                  {{$t('messages.nopaymentmethod')}}
                </div>
                <div class="mt-n2">
                  <a href="#" class="btn btn-sm ms-0 ps-0" :class="adminSelectedUser?'text-muted pe-none':'text-primary'" @click.prevent="!adminSelectedUser && updatePaymentMethod()">{{$t('messages.change')}}</a>
                </div>
              </template>

              <div class="fw-bold fs-xs mt-2 mb-1"><i class="bi bi-credit-card"></i> {{$t('messages.billingdetails')}}</div>
              <div class="fs-sm"><span class="text-muted">{{$t('messages.email')}}:</span> {{email}}</div>
              <div v-if="!noAdminPermissions" class="mt-n2">
                <a href="#" class="btn btn-sm ms-0 ps-0" :class="adminSelectedUser?'text-muted pe-none':'text-primary'" @click.prevent="!adminSelectedUser && updateCustomerInfo()">{{$t('messages.updatecustomerinfo')}}</a>
              </div>
          </div>

          <div class="mb-3 col-12 col-md-6 col-xl-3">
              <div class="fw-bold fs-xs mb-1"><i class="bi bi-bar-chart"></i> {{$t('messages.usage')}}</div>
              <div class="fs-sm"><span class="text-muted">{{$t('messages.todayqueries')}}:</span> {{formatUsageNumber(todayQueryCount)}} {{$t('messages.queries')}} / {{formatUsageNumber(todayQueryCost)}} {{$t('messages.cost')}}</div>
              <div class="fs-sm"><span class="text-muted">{{$t('messages.periodqueries')}}:</span> {{formatUsageNumber(periodQueryCount)}} {{$t('messages.queries')}} / {{formatUsageNumber(periodQueryCost)}} {{$t('messages.cost')}}</div>
              <div class="mt-n2">
                <a :href="usageLink" class="btn btn-sm text-primary ms-0 ps-0">{{$t('messages.recentusage')}}</a>
              </div>
          </div>


        </div>
        <div class="mb-2">
          <a href="#" class="btn btn-sm text-muted ms-0 ps-0" :class="{'pe-none opacity-50':adminSelectedUser}" @click.prevent="!adminSelectedUser && deleteAccount(false)"><i class="bi bi-trash3"></i> {{$t('messages.deleteaccount')}}</a>
        </div>
      </div>

      <!-- Team Members & API Keys section -->
      <div v-if="customerInfo" class="col-12 card card-body border-0 shadow-sm py-2 px-4 mt-3">
        <h4 class="mt-3 mb-2">Manage Team Members and API Keys</h4>
        <div v-if="!showChildUserManager" class="text-muted mb-3">
          Your plan does not permit multiple users or keys.
        </div>
        <div v-else class="mb-3">
          <span class="text-muted">You have used {{customerInfo.actualUserCount >= 0 ? customerInfo.actualUserCount : 0}} of your {{maxChildUsers}} permitted accounts.</span>
          <div class="mt-1">
            <a href="#" class="btn btn-sm text-primary ms-0 ps-0" @click.prevent="openModal('childUsers')"><i class="bi bi-people me-1"></i>Manage Team</a>
          </div>
        </div>
      </div>

      <PriceList :parentCustomerInfo="customerInfo" :isChild="true" :showFeatures="false" :showCurrentSubs="true" class="col-12 mt-3" />
      
    </div>

    <!-- Child User Manager Modal -->
    <div v-if="showChildUserManager" class="modal" :class="{ show: modals.childUsers.isOpen }" :style="{ display: modals.childUsers.isOpen ? 'block' : 'none' }" tabindex="-1" @click.self="closeModal('childUsers')">
      <div v-if="modals.childUsers.isOpen" class="modal-backdrop fade show" @click="closeModal('childUsers')"></div>
      <div class="modal-dialog modal-lg modal-dialog-centered" style="z-index:1060;">
        <div class="modal-content">
          <div class="modal-header py-2">
            <h6 class="modal-title"><i class="bi bi-people me-2"></i>Team Members</h6>
            <button type="button" class="btn-close btn-close-sm" @click="closeModal('childUsers')"></button>
          </div>
          <div class="modal-body p-0">
            <ChildUserManager :maxChildUsers="maxChildUsers" />
          </div>
        </div>
      </div>
    </div>
   

    <!-- Change Password Modal -->
    <div class="modal" :class="{ 'fade': true, 'show': modals.changePassword.isOpen }" 
         :style="{ display: modals.changePassword.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="changePasswordModalLabel" 
         :aria-hidden="!modals.changePassword.isOpen"
         @click.self="cancelChangePassword()">
      
      <div v-if="modals.changePassword.isOpen" class="modal-backdrop fade show" @click="cancelChangePassword()"></div>
      
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="changePasswordModalLabel">{{$t('changePassword.changePasswordButton')}}</h5>
            <button type="button" class="btn-close" @click="cancelChangePassword()" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="pwdChangeError" class="alert alert-danger py-1 px-2 mb-2 fs-xs">{{pwdChangeError}}</div>

            <template v-if="pwdChangeMode==='input'">
              <p class="fs-sm">{{$t('messages.pwdcodeinstructions')}}</p>
            </template>

            <form v-if="pwdChangeMode==='verify'" @submit.prevent="changePassword()" autocomplete="on">
              <input type="email" name="username" autocomplete="username" :value="username" tabindex="-1" aria-hidden="true" style="position:absolute;opacity:0;height:0;width:0;padding:0;border:0;" />
              <div class="mb-3">
                <label class="form-label fs-sm mb-1">{{$t('changePassword.enterCodeLabel')}}</label>
                <input type="text" class="form-control form-control-sm" v-model="pwdAuthCode" :placeholder="$t('changePassword.codePlaceholder')" autocomplete="one-time-code" inputmode="numeric" maxlength="5" />
                <div class="mt-1">
                  <a v-if="pwdCodeCountdown<=0" href="#" class="fs-xs" @click.prevent="requestPasswordCode()">{{$t('messages.requestnewcode')}}</a>
                  <span v-else class="fs-xs text-muted">{{$t('messages.requestnewcodein', {seconds: pwdCodeCountdown})}}</span>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label fs-sm mb-1" for="pwdNew1">{{$t('changePassword.newPasswordLabel')}}</label>
                <div class="input-group input-group-sm">
                  <input v-model="pwdPassword1" name="new-password" class="form-control form-control-sm" :type="pwdShowPassword ? 'text' : 'password'" id="pwdNew1" autocomplete="new-password" :placeholder="$t('changePassword.newPasswordPlaceholder')" />
                  <button class="btn btn-outline-secondary btn-sm" type="button" @click="pwdShowPassword=!pwdShowPassword">
                    <i class="bi" :class="pwdShowPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                  </button>
                </div>
                <div v-if="pwdPassword1" class="mt-1 small">
                  <span :class="pwdPassword1.length>=8 ? 'text-success' : 'text-danger'"><i class="bi" :class="pwdPassword1.length>=8 ? 'bi-check-circle-fill' : 'bi-x-circle'"></i> {{$t('changePassword.pwd_length')}}</span><br/>
                  <span :class="/[A-Z]/.test(pwdPassword1) ? 'text-success' : 'text-danger'"><i class="bi" :class="/[A-Z]/.test(pwdPassword1) ? 'bi-check-circle-fill' : 'bi-x-circle'"></i> {{$t('changePassword.pwd_uppercase')}}</span><br/>
                  <span :class="/[a-z]/.test(pwdPassword1) ? 'text-success' : 'text-danger'"><i class="bi" :class="/[a-z]/.test(pwdPassword1) ? 'bi-check-circle-fill' : 'bi-x-circle'"></i> {{$t('changePassword.pwd_lowercase')}}</span><br/>
                  <span :class="/[0-9]/.test(pwdPassword1) ? 'text-success' : 'text-danger'"><i class="bi" :class="/[0-9]/.test(pwdPassword1) ? 'bi-check-circle-fill' : 'bi-x-circle'"></i> {{$t('changePassword.pwd_number')}}</span>
                </div>
              </div>
              <div class="mb-2">
                <label class="form-label fs-sm mb-1" for="pwdNew2">{{$t('changePassword.confirmPasswordLabel')}}</label>
                <input v-model="pwdPassword2" name="confirm-password" class="form-control form-control-sm" :type="pwdShowPassword ? 'text' : 'password'" id="pwdNew2" autocomplete="new-password" :placeholder="$t('changePassword.confirmPasswordPlaceholder')" />
                <div v-if="pwdPassword2 && pwdPassword1!==pwdPassword2" class="small text-danger mt-1"><i class="bi bi-x-circle"></i> {{$t('changePassword.pwd_mismatch')}}</div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-outline-secondary" @click="cancelChangePassword()">{{$t('messages.cancel')}}</button>
            <button v-if="pwdChangeMode==='input'" class="btn btn-sm btn-primary" :disabled="pwdChangeSubmitting" @click="requestPasswordCode()">{{$t('changePassword.requestCodeButton')}}</button>
            <button v-if="pwdChangeMode==='verify'" class="btn btn-sm btn-primary" :disabled="!canSubmitPasswordChange || pwdChangeSubmitting" @click="changePassword()">{{$t('changePassword.changePasswordButton')}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Username Change Modal -->
    <div class="modal" :class="{ 'fade': true, 'show': modals.usernameChange.isOpen }" 
         :style="{ display: modals.usernameChange.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="usernameChangeModalLabel" 
         :aria-hidden="!modals.usernameChange.isOpen"
         @click.self="cancelUsernameChange()">
      
      <div v-if="modals.usernameChange.isOpen" class="modal-backdrop fade show" @click="cancelUsernameChange()"></div>
      
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="usernameChangeModalLabel">{{$t('messages.changeusername')}}</h5>
            <button type="button" class="btn-close" @click="cancelUsernameChange()" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="usernameChangeError" class="alert alert-danger py-1 px-2 mb-2 fs-xs">{{usernameChangeError}}</div>

            <template v-if="usernameChangeMode==='input'">
              <label class="form-label fs-sm mb-1">{{$t('messages.newemailaddress')}}</label>
              <input type="email" class="form-control form-control-sm mb-3" v-model="newUsername" :placeholder="$t('messages.newemailplaceholder')" @keyup.enter="requestUsernameChange()" />
            </template>

            <template v-if="usernameChangeMode==='verify'">
              <div class="fs-sm mb-2">{{$t('messages.verificationcodesent')}}</div>
              <label class="form-label fs-sm mb-1">{{$t('messages.verificationcode')}}</label>
              <input type="text" class="form-control form-control-sm mb-2" v-model="verificationCode" :placeholder="$t('messages.entercode')" @keyup.enter="confirmUsernameChange()" />
              <div class="mb-3">
                <a v-if="codeCountdown<=0" href="#" class="fs-xs" @click.prevent="requestUsernameChange()">{{$t('messages.requestnewcode')}}</a>
                <span v-else class="fs-xs text-muted">{{$t('messages.requestnewcodein', {seconds: codeCountdown})}}</span>
              </div>
              <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" v-model="updateBillingEmail" id="updateBillingEmailCheck" />
                <label class="form-check-label fs-sm" for="updateBillingEmailCheck">{{$t('messages.updatebillingemail')}}</label>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-outline-secondary" @click="cancelUsernameChange()">{{$t('messages.cancel')}}</button>
            <button v-if="usernameChangeMode==='input'" class="btn btn-sm btn-primary" :disabled="!newUsername || usernameChangeSubmitting" @click="requestUsernameChange()">{{$t('messages.sendverificationcode')}}</button>
            <button v-if="usernameChangeMode==='verify'" class="btn btn-sm btn-primary" :disabled="!verificationCode || usernameChangeSubmitting" @click="confirmUsernameChange()">{{$t('messages.confirm')}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- STRIPE OPENING Modal -->

    <div class="modal" :class="{ 'fade': true, 'show': modals.stripePageOpen.isOpen }" 
         :style="{ display: modals.stripePageOpen.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="stripePageOpenModalLabel" 
         :aria-hidden="!modals.stripePageOpen.isOpen">
      
      <div v-if="modals.stripePageOpen.isOpen" class="modal-backdrop fade show"></div>
      
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="d-flex align-items-center justify-content-center">
              <div class="spinner-border" role="status"></div>
              <div class="ms-2">{{$t('messages.openingPaymentPage')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!-- Modal -->
    <div class="modal" :class="{ 'fade': true, 'show': modals.secretKey.isOpen }" 
         :style="{ display: modals.secretKey.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="secretKeyModalLabel" 
         :aria-hidden="!modals.secretKey.isOpen"
         @click.self="closeModal('secretKey')">
      
      <div v-if="modals.secretKey.isOpen" class="modal-backdrop fade show" @click="closeModal('secretKey')"></div>
      
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="secretKeyModalLabel">
              {{$t('messages.secretkeymodaltitle')}}
            </h5>
            <button type="button" class="btn-close" @click="closeModal('secretKey')" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p><strong>{{$t('messages.yournewsecretkey')}}</strong></p>
            <div class="input-group mb-3">
              <input type="text" id="secretKeyValue" class="form-control" readonly v-model="localSecretKey">
              <button class="btn btn-secondary" type="button" @click="copySecretKey($event)">{{$t('messages.copy')}}</button>
            </div>
            <div class="alert alert-info" role="alert">
              {{$t('messages.copysecretkeywarning')}}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="closeModal('secretKey')">Ok</button>
          </div>
        </div>
      </div>
    </div>
    


    <!-- Email Preferences Modal -->
    <div class="modal" :class="{ 'fade': true, 'show': modals.emailPrefs.isOpen }" 
         :style="{ display: modals.emailPrefs.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="emailPrefsModalLabel" 
         :aria-hidden="!modals.emailPrefs.isOpen"
         @click.self="closeModal('emailPrefs')">
      
      <div v-if="modals.emailPrefs.isOpen" class="modal-backdrop fade show" @click="closeModal('emailPrefs')"></div>
      
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="emailPrefsModalLabel">
              <i class="bi bi-bell"></i> {{ $t('messages.emailprefs.title') }}
            </h5>
            <button type="button" class="btn-close" @click="closeModal('emailPrefs')" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-check mb-2">
              <input class="form-check-input" type="checkbox" id="acct-pref-service" checked disabled />
              <label class="form-check-label text-muted" for="acct-pref-service">{{ $t('messages.emailprefs.service') }}</label>
            </div>
            <div class="form-check mb-2">
              <input class="form-check-input" type="checkbox" id="acct-pref-news" v-model="emailPrefs.news_and_announcements" />
              <label class="form-check-label" for="acct-pref-news">{{ $t('messages.emailprefs.news_and_announcements') }}</label>
            </div>
            <div class="form-check mb-2">
              <input class="form-check-input" type="checkbox" id="acct-pref-marketing" v-model="emailPrefs.marketing" />
              <label class="form-check-label" for="acct-pref-marketing">{{ $t('messages.emailprefs.marketing') }}</label>
            </div>
          </div>
          <div class="modal-footer">
            <span v-if="emailPrefsSaved" class="text-success me-auto small"><i class="bi bi-check-circle"></i> {{ $t('messages.emailprefs.saved') }}</span>
            <span v-if="emailPrefsError" class="text-danger me-auto small">{{ $t('messages.emailprefs.error') }}</span>
            <button type="button" class="btn btn-secondary" @click="closeModal('emailPrefs')">{{ $t('messages.emailprefs.close') }}</button>
            <button type="button" class="btn btn-primary" :disabled="isSavingEmailPrefs" @click="saveEmailPreferences">
              <span v-if="isSavingEmailPrefs" class="spinner-border spinner-border-sm me-1" role="status"></span>
              {{ isSavingEmailPrefs ? $t('messages.emailprefs.saving') : $t('messages.emailprefs.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <CommonModals />
    <div class="fs-sm text-muted">Version: {{ VcGlobal.VERSION }}</div>
  </div>
 
</template>
<script setup>
import { i18Utils } from "@/visualcrossing-core/i18utils";
</script>
<script>
import CommonModals from './CommonModals.vue'
import PriceList from './PriceList.vue';
import ChildUserManager from './account/ChildUserManager.vue';
import "/src/visualcrossing-core/vccommunicator_account";
import "/src/visualcrossing-core/vccommunicator_serveradmin";
import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
import {VcGlobal} from '/src/visualcrossing-core/vcglobal_conn';
import {VcClipboardUtils} from '/src/visualcrossing-core/vcclipboardutils';
import '/src/website-core/VcUtils';
import {VcValidation} from '/src/visualcrossing-core/vcvalidation';
import translations from '@/translations/accountsummary.js';
import changepassword from "@/translations/changepassword";


export default {
  i18n: {
      messages: {
        en: { ...translations.en, ...changepassword.en },
        de: { ...translations.de, ...changepassword.de },
      },
  },
  name: 'account',
  props: {
    
  },
  data() {
    return {
      // Modal state management
      modals: {
        stripePageOpen: { isOpen: false },
        secretKey: { isOpen: false },
        addressBook: { isOpen: false },
        emailPrefs: { isOpen: false },
        usernameChange: { isOpen: false },
        changePassword: { isOpen: false },
        childUsers: { isOpen: false },
      },

      isCopying:false,
      isContainerInited:false,
      sessionId:null,
      sessionState:null,
      errorStatus:null,
      noAdminPermissions:false,
      customerInfo:null,
      isLoading:false,
      submitted:false,
      requestedPlan:null,
      localApikey:null,
      localSecretKey:null,
      //subscriptionToCancel:null,
      //cancellationComment:null,
      stripeLinkOpening:false,
      emailPrefs: {
        news_and_announcements: false,
        marketing: false,
      },
      isSavingEmailPrefs: false,
      emailPrefsSaved: false,
      emailPrefsError: false,
      adminSearchCriteria:'',
      adminSearchResults:null,
      adminSelectedUser:null,
      adminSearchError:null,
      isAdminSearching:false,
      // Username change state
      usernameChangeMode:null, // null, 'input', 'verify'
      newUsername:'',
      updateBillingEmail:true,
      verificationCode:'',
      usernameChangeBillingMatch:false,
      usernameChangeError:null,
      usernameChangeSubmitting:false,
      codeCountdown:0,
      codeCountdownTimer:null,
      // Change password state
      pwdChangeMode:null, // null, 'input', 'verify'
      pwdPassword1:'',
      pwdPassword2:'',
      pwdShowPassword:false,
      pwdAuthCode:'',
      pwdCodeSent:false,
      pwdChangeError:null,
      pwdChangeSubmitting:false,
      pwdCodeCountdown:0,
      pwdCodeCountdownTimer:null,
    }
  },
  methods:{
    // New modal control methods
    openModal(modalName) {
      this.modals[modalName].isOpen = true;
    },

    closeModal(modalName) {
      this.modals[modalName].isOpen = false;
    },

    closeAllModals() {
      Object.keys(this.modals).forEach(key => {
        this.modals[key].isOpen = false;
      });
    },

    // Handle ESC key
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        // Find and close the first open modal
        const openModal = Object.keys(this.modals).find(key => this.modals[key].isOpen);
        if (openModal) {
          this.closeModal(openModal);
        }
      }
    },

    startUsernameChange() {
      this.usernameChangeMode='input';
      this.newUsername='';
      this.verificationCode='';
      this.usernameChangeError=null;
      this.usernameChangeBillingMatch=false;
      this.updateBillingEmail=true;
      this.usernameChangeSubmitting=false;
      this.openModal('usernameChange');
    },
    cancelUsernameChange() {
      this.closeModal('usernameChange');
      this.usernameChangeMode=null;
      this.newUsername='';
      this.verificationCode='';
      this.usernameChangeError=null;
      this.usernameChangeBillingMatch=false;
      this.usernameChangeSubmitting=false;
      this.clearCodeCountdown();
    },
    startCodeCountdown() {
      this.clearCodeCountdown();
      this.codeCountdown=30;
      this.codeCountdownTimer=setInterval(() => {
        this.codeCountdown--;
        if (this.codeCountdown<=0) this.clearCodeCountdown();
      }, 1000);
    },
    clearCodeCountdown() {
      if (this.codeCountdownTimer) {
        clearInterval(this.codeCountdownTimer);
        this.codeCountdownTimer=null;
      }
      this.codeCountdown=0;
    },
    // Change password methods
    startChangePassword() {
      this.pwdChangeMode='input';
      this.pwdPassword1='';
      this.pwdPassword2='';
      this.pwdShowPassword=false;
      this.pwdAuthCode='';
      this.pwdCodeSent=false;
      this.pwdChangeError=null;
      this.pwdChangeSubmitting=false;
      this.clearPwdCodeCountdown();
      this.openModal('changePassword');
      this.$nextTick(() => {
        var el=document.getElementById('pwdNew1');
        if (el) el.focus();
      });
    },
    cancelChangePassword() {
      this.closeModal('changePassword');
      this.pwdChangeMode=null;
      this.pwdPassword1='';
      this.pwdPassword2='';
      this.pwdShowPassword=false;
      this.pwdAuthCode='';
      this.pwdCodeSent=false;
      this.pwdChangeError=null;
      this.pwdChangeSubmitting=false;
      this.clearPwdCodeCountdown();
    },
    requestPasswordCode() {
      var me=this;
      me.pwdChangeError=null;
      me.pwdChangeSubmitting=true;
      vcCommunicator.generateAuthCode(me.username)
        .then(function() {
          me.pwdChangeSubmitting=false;
          me.pwdChangeMode='verify';
          me.startPwdCodeCountdown();
        }).catch(function(error) {
          me.pwdChangeSubmitting=false;
          me.pwdChangeError=me.$t('changePassword.errorRequestCodeMessage', {error: error});
        });
    },
    changePassword() {
      var me=this;
      if (!me.canSubmitPasswordChange) return;
      me.pwdChangeError=null;
      me.pwdChangeSubmitting=true;
      vcCommunicator.changeuserpassword(me.username, me.pwdPassword1, me.pwdAuthCode)
        .then(function() {
          me.pwdChangeSubmitting=false;
          me.cancelChangePassword();
          window.VcCommonModals.showAlert(me.$t('changePassword.passwordChangedTitle'), me.$t('changePassword.passwordChangedMessage'));
        }).catch(function(error) {
          me.pwdChangeSubmitting=false;
          me.pwdChangeError=me.$t('changePassword.errorChangePasswordMessage', {error: error});
        });
    },
    startPwdCodeCountdown() {
      this.clearPwdCodeCountdown();
      this.pwdCodeCountdown=30;
      this.pwdCodeCountdownTimer=setInterval(() => {
        this.pwdCodeCountdown--;
        if (this.pwdCodeCountdown<=0) this.clearPwdCodeCountdown();
      }, 1000);
    },
    clearPwdCodeCountdown() {
      if (this.pwdCodeCountdownTimer) {
        clearInterval(this.pwdCodeCountdownTimer);
        this.pwdCodeCountdownTimer=null;
      }
      this.pwdCodeCountdown=0;
    },
    requestUsernameChange() {
      var me=this;
      if (!me.newUsername) return;
      me.usernameChangeError=null;
      me.usernameChangeSubmitting=true;
      vcCommunicator.requestUsernameChange(me.newUsername)
        .then(function(data) {
          me.usernameChangeSubmitting=false;
          if (data.errorCode) {
            me.usernameChangeError=data.message || 'Request failed';
            return;
          }
          if (!data.availableEmail) {
            me.usernameChangeError=data.info || me.$t('messages.emailnotavailable');
            return;
          }
          if (!data.sentVerificationCode) {
            me.usernameChangeError='Failed to send verification code. Please try again.';
            return;
          }
          me.usernameChangeBillingMatch=data.billingEmailMatch;
          me.updateBillingEmail=data.billingEmailMatch;
          me.usernameChangeMode='verify';
          me.startCodeCountdown();
        }).catch(function(error) {
          me.usernameChangeSubmitting=false;
          me.usernameChangeError='Error: '+error;
        });
    },
    confirmUsernameChange() {
      var me=this;
      if (!me.verificationCode) return;
      me.usernameChangeError=null;
      me.usernameChangeSubmitting=true;
      vcCommunicator.confirmUsernameChange(me.newUsername, me.verificationCode, me.updateBillingEmail)
        .then(function(data) {
          me.usernameChangeSubmitting=false;
          if (data.errorCode) {
            me.usernameChangeError=data.message || 'Confirmation failed';
            return;
          }
          if (!data.success) {
            me.usernameChangeError='Username change failed. Please try again.';
            return;
          }
          // Update the session with the new JWT so subsequent requests use the new email
          if (data.sessionId) {
            vcCommunicator.sessionId=data.sessionId;
            vcCommunicator.setCookie('sessionId', data.sessionId);
          }
          me.cancelUsernameChange();
          me.refreshCustomerInfo();
          window.VcCommonModals.showAlert(me.$t('messages.usernamechanged'), me.$t('messages.usernamechangeddesc'));
        }).catch(function(error) {
          me.usernameChangeSubmitting=false;
          me.usernameChangeError='Error: '+error;
        });
    },

    deleteAccount(confirm) {
      var me=this;
      if (!confirm) {
         window.VcCommonModals.showConfirm(me.$t("messages.confirmDeleteTitle"), me.$t("messages.confirmDeleteDesc"))
          .then(function(id) {
             me.deleteAccount(true);
          }).catch((error) => {
            console.log("User said no to reenable accout"+error)
          });
        return;
      }

      me.submitted=true;
      vcCommunicator.deleteaccount() 
        .then(function (result) {
          me.submitted=false;
          vcCommunicator.signOut()
            .then(() => {
              this.sessionId = vcCommunicator.sessionId;
            })
            .catch((error) => {
              console.log("Sign out failed:", error);
              this.sessionId = null;
            });
        }).catch((error) => {
          me.submitted=false;
          me.errorStatus="Error deleting account. <br/>"+error;
        });
    },

    reenableAccount:function(confirm) {
      var me=this;
      if (!confirm) {
         window.VcCommonModals.showConfirm(me.$t("messages.confirmReenableTitle"), me.$t("messages.confirmReenableDesc"))
          .then(function(id) {
             me.reenableAccount(true);
          }).catch((error) => {
            console.log("User said no to reenable accout"+error)
          });
        return;
      }

      me.submitted=true;
      vcCommunicator.reenableaccount() 
        .then(function (result) {
          me.submitted=false;
          me.refreshCustomerInfo();
        }).catch((error) => {
          me.submitted=false;
          me.errorStatus="Error re-enabling account. <br/>"+error;
        });


    },

    changeSecret:function(confirm) {
      let me=this;
      if (!confirm) {
         window.VcCommonModals.showConfirm(me.$t("messages.confirmSecretChangeTitle"), me.$t("messages.confirmSecretChangeDesc"))
          .then(function(id) {
             me.changeSecret(true);
          }).catch((error) => {
            console.log("User said no to change secret "+error)
          });
        return;
      }

      me.submitted=true;
      vcCommunicator.changeSecret() 
        .then(function (result) {
          me.submitted=false;
          me.localSecretKey = result.newSecret;

          // Use Vue modal instead of Bootstrap
          me.openModal('secretKey');
         


        }).catch((error) => {
          me.submitted=false;
          me.errorStatus="Error changing secret. <br/>"+error;
        });
    },

    changeApiKey:function(confirm) {
      var me=this;
      if (!confirm) {
         window.VcCommonModals.showConfirm(me.$t("messages.confirmApiKeyChangeTitle"), me.$t("messages.confirmApiKeyChangeDesc"))
          .then(function(id) {
             me.changeApiKey(true);
          }).catch((error) => {
            console.log("User said no to chage key "+error)
          });
        return;
      }

      me.submitted=true;
      vcCommunicator.changeApiKey() 
        .then(function (result) {
          me.submitted=false;
          me.localApikey=result.newKey;
          //me.refreshCustomerInfo();
        }).catch((error) => {
          me.submitted=false;
          //me.refreshCustomerInfo();
          me.errorStatus="Error changing API key. <br/>"+error;
        });


    },
    copyKey:function() {
      let me=this;
      VcClipboardUtils.copyToClipboard(this.apiKey);
      this.isCopying=true;
      setTimeout(() => {
        me.isCopying=false;
      }, 2000);
      
    },
    
    copySecretKey:function(event) {
      let me=this;
      VcClipboardUtils.copyToClipboard(this.localSecretKey);
      VcUtils.changeButtonTextTemporarily(event.target, me.$t("messages.copying"), 2000); //change button text to "Copied!" for 2 seconds
     
    },
    formatUsageNumber(value) {
      if (value===null || value===undefined || value<0) return '—';
      return value.toLocaleString();
    },
    updateCustomerInfo() {
      var me=this;
      me.createportalsession("customer_info_update");
    },
    refreshCustomerInfo() {
      var me=this;
      me.isLoading=true;
      me.customerInfo=null;
      if (!me.hasSession) return;
      vcCommunicator.accountPageInfo()
        .then(function (result) {
          me.isLoading=false;
          me.errorStatus=null;
          me.customerInfo=result;
          me.noAdminPermissions=false;
          
          // Populate email preferences from server response
          if (result && result.emailPreferences && result.emailPreferences.preferences) {
            me.emailPrefs = {
              news_and_announcements: !!result.emailPreferences.preferences.news_and_announcements,
              marketing: !!result.emailPreferences.preferences.marketing,
            };
          }
          
          if (me.requestedPlan)  {
            me.showRequestPlan();
          }
          
         // if (!me.primarySubscription) {
         //   me.requestPricingTableSession();
         // }

        }).catch((error) => {
          me.isLoading=false;
          if (error && error.indexOf("administrative permissions")) {
            me.noAdminPermissions=true;
          } else {
            me.errorStatus="There was a problem loading the information. <br/>"+error;
            me.noAdminPermissions=false;
          }
        
        });
    },
    saveEmailPreferences() {
      var me = this;
      me.isSavingEmailPrefs = true;
      me.emailPrefsSaved = false;
      me.emailPrefsError = false;

      vcCommunicator.saveEmailPreferences(me.emailPrefs)
        .then(function(result) {
          me.isSavingEmailPrefs = false;
          if (result && result.errorCode) {
            me.emailPrefsError = true;
          } else {
            me.emailPrefsSaved = true;
            setTimeout(() => { me.emailPrefsSaved = false; }, 3000);
          }
        })
        .catch(function(error) {
          me.isSavingEmailPrefs = false;
          me.emailPrefsError = true;
        });
    },
    createportalsession(flowType, subscriptionId, planId, id) {
      var me=this;

      if (!flowType) {
        flowType="testconfig";
      }

      me.submitted=true;

      me.stripeLinkOpening=true;

      //me.showModal('#primaryPlanChooserModal', false);

      vcCommunicator.createportalsession(flowType, subscriptionId, planId, id)
        .then(function (result) {
          me.submitted=false;
          me.stripeLinkOpening=false;
          console.log("createPortalSession", result)
          window.location.href = result.url;
        }).catch((error) => {
          me.submitted=false;
           me.stripeLinkOpening=false;
          me.errorStatus="Error creating portal session. <br/>"+error;
        });
    },
    updatePaymentMethod() {
      var me=this;
      me.createportalsession("payment_method_update");
    },
    adminFindUser() {
      var me=this;
      if (!me.adminSearchCriteria) return;
      me.isAdminSearching=true;
      me.adminSearchError=null;
      me.adminSearchResults=null;
      me.adminSelectedUser=null;
      
      vcCommunicator.findUser(me.adminSearchCriteria)
        .then(function(result) {
          me.isAdminSearching=false;
          me.adminSearchResults=result;
        }).catch(function(error) {
          me.isAdminSearching=false;
          me.adminSearchError='Search failed: '+error;
        });
    },
    adminSelectUser(result) {
      var me=this;
      me.adminSelectedUser=result.username;
      me.adminSearchResults=null;
      me.localApikey=null;
      me.isLoading=true;
      me.errorStatus=null;
      
      vcCommunicator.getUserAccountPageInfo(result.username)
        .then(function(data) {
          me.isLoading=false;
          if (!data || !data.username) {
            me.errorStatus='No account information available for this user';
            return;
          }
          me.customerInfo=data;
        }).catch(function(error) {
          me.isLoading=false;
          me.errorStatus='Failed to load account info for user: '+error;
        });
    },
    adminClearSearch() {
      var me=this;
      me.adminSelectedUser=null;
      me.adminSearchResults=null;
      me.adminSearchCriteria='';
      me.adminSearchError=null;
      me.refreshCustomerInfo();
    },
  },
  computed:{
    usageLink() {
      return i18Utils.link("usage");
    },
    accountLink() {
      return i18Utils.link("account");
    },
    signupLink() {
      return i18Utils.link("sign-up");
    },
    changepasswordLink() {
      return i18Utils.link("change-password");
    },
    canSubmitPasswordChange() {
      return this.pwdAuthCode && this.pwdAuthCode.length===5 && VcValidation.validatePassword(this.pwdPassword1) && this.pwdPassword1===this.pwdPassword2;
    },
    executionStatus() {
      let me=this;
      return (me.customerInfo && me.customerInfo.executionStatus) || 0;
    },
    executionStatusLabel() {
      let me=this;
      const status=me.customerInfo && me.customerInfo.executionStatus;
      switch (status) {
        case 1:
          return "Your account is disabled because your most recent payment failed. Please update your payment information or resubmit the failed payments.";
        case 2:
          return "Your account is disabled because of excessive error or overage queries. ";
        default:
          return null;
      }
    },
    taxIdDetails() {
      let me=this;
      if (!me.selectedTaxType) return "";
      return me.selectedTaxType[2];
    },
    taxIdExample() {
      let me=this;
      if (!me.selectedTaxType) return "";
      return me.selectedTaxType[3];
    },
    subscriptionStatus() {
       let me=this;
       const subs=me.sessionId && me.customerInfo && me.customerInfo.subscriptions;
       if (!subs) return null;
       return subs.reduce(function(a,d) {
          if (d.status && d.status!=='active' && d.status!=='trialing') return d.status;
          return a;
       }, null);
    },
    subscriptionStatusLabel() {
       let me=this;
       switch (me.subscriptionStatus) {
         case 'past_due':
           return me.$t('messages.subscriptionpastdue');
         case 'unpaid':
           return me.$t('messages.subscriptionunpaid');
         case 'canceled':
           return me.$t('messages.subscriptioncanceled');
         default:
           return null;
       }
       
    },
    email() {
       return this.customerInfo && this.customerInfo.email;
    },
    username() {
      return this.customerInfo && this.customerInfo.username;
    },  
    apiKey() {
      return this.localApikey || (this.customerInfo && this.customerInfo.apiKey) || (this.sessionState && this.sessionState.apiKey);
    },
    apiVersion() {
      return (this.customerInfo && this.customerInfo.apiVersion) || this.subscriptionParams?.apiVersion || "1.0";
    },
    todayQueryCount() {
      return this.customerInfo ? this.customerInfo.todayQueryCount : -1;
    },
    periodQueryCount() {
      return this.customerInfo ? this.customerInfo.periodQueryCount : -1;
    },
    todayQueryCost() {
      return this.customerInfo ? this.customerInfo.todayQueryCost : -1;
    },
    periodQueryCost() {
      return this.customerInfo ? this.customerInfo.periodQueryCost : -1;
    },
    hasPaymentMethod() {
      return this.paymentMethod && this.customerInfo.hasValidPaymentSource;
    },
    paymentMethod() {
      return this.customerInfo && this.customerInfo.defaultSource;
    },
    subscriptionParams() {
      return this.sessionState && this.sessionState.subscriptionParams;
    },
    hasSession() {
      return this.sessionId;
    },
    isAdmin() {
      return this.sessionState && this.sessionState.contextProperties && 
        this.sessionState.contextProperties.isAdmin==="true";
    },
    maxChildUsers() {
      return this.customerInfo && this.customerInfo.maxDescendantUsers || 1;
    },
    showChildUserManager() {
      return this.customerInfo && this.customerInfo.isClientAdmin && this.maxChildUsers > 1 && !this.adminSelectedUser;
    },
  },
  watch: {

  },
  updated() {

  },
  unmounted() {
    var me=this;
   // me.unmountStripe();
  },
  mounted() {
    var me=this;
    // Add ESC key listener
    document.addEventListener('keydown', this.handleKeyDown);

    me.requestedPlan=VcUtils.qs["pln"] || null;

   


    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
   
    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    me.isContainerInited=vcCommunicator.isInited || me.sessionId;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
      me.isContainerInited=true;
      me.refreshCustomerInfo();
    });
    vcCommunicator.addHandler('createsessionfailed', function (sessionId,sessionState) {
      me.sessionId=null;
      me.sessionState=null;

      me.isContainerInited=true;
     
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
       me.customerInfo=null;
       me.adminSelectedUser=null;
       me.adminSearchResults=null;
       me.adminSearchCriteria='';
       me.adminSearchError=null;
       me.localApikey=null;
    });

   // me.mountStripe();
    
    me.refreshCustomerInfo();


    let checkoutSessionId=VcUtils.qs["session_id"] || null;
    if (checkoutSessionId) {
      me.processCheckoutSession(checkoutSessionId);
    }
  },

  beforeUnmount() {
    // Clean up event listener
    document.removeEventListener('keydown', this.handleKeyDown);
  },

  components: {
    CommonModals,
    PriceList,
    ChildUserManager,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wizardstep {
    min-height:200px;
  }

  /* Modal styles to ensure proper display without Bootstrap JS */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1055;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal.show {
  display: block !important;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-dialog {
  position: relative;
  z-index: 1060;
}
</style>